import React from 'react';
import Table from 'react-bootstrap/Table';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import {CollapsibleComponent, CollapsibleHead, CollapsibleContent} from 'react-collapsible-component';

import OasisPoolNav from './OasisPoolNav';
import SPUtilities from "../util/SPUtilities";
import AddressUtils from "../util/AddressUtils";
import OasisUtils from "./OasisUtils";
import UIUtils from "../util/UIUtils";
import RespUtils from "../util/RespUtils";


class OasisPoolInline extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
    }
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  componentWillMount() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  async componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
  }

  render() {
    // let lastUpdatedDate = new Date(Date.parse(this.props.pool.lastUpdated));
    // console.log(this.props.pool);

    return (
      <div>
        {this.infoNeededMsg()}
        <Table striped bordered size="sm">
          <tbody>
            <tr>
              <th align="left">Validator: </th>
              <td align="left"> {this.props.pool.entityName} {UIUtils.getRiskyInd(this.props.pool.risky)}</td>
            </tr>
            <tr>
              <th align="left">Website: </th>
              <td align="left"> {OasisUtils.websiteLink(this.props.pool.website, this.props.pool.website)}</td>
            </tr>
            <tr>
              <th align="left">Description: </th>
              <td align="left">{UIUtils.getRiskyInd(this.props.pool.risky)} {this.props.pool.description}</td>
            </tr>
            <tr>
              <th align="left">Commission: </th>
              <td align="left"> {this.props.pool.commission}</td>
            </tr>
            <tr>
              <th align="left">Entity Address: </th>
              <td align="left"> {AddressUtils.addressFormatterSimpleWithLink(this.props.pool.idAddress)}</td>
            </tr>
            <tr>
              <th align="left">Entity ID (hex): </th>
              <td align="left"> {AddressUtils.addressFormatterSimple(this.props.pool.idAddressHex)}</td>
            </tr>
            <tr>
              <th align="left">Public Key: </th>
              <td align="left"> {AddressUtils.addressFormatterSimple(this.props.pool.publicKey)}</td>
            </tr>
            <tr>
              <th align="left">Nodes: </th>
              <td align="left"> {AddressUtils.addressFormatterSimple(this.props.pool.nodes)}</td>
            </tr>
            <tr>
              <th align="left">In Consensus: </th>
              <td align="left"> {this.props.pool.selectedInd}</td>
            </tr>
            <tr>
              <th align="left">Voting Power: </th>
              <td align="left"> {this.props.pool.votingPower}</td>
            </tr>
            <tr>
              <th align="left">General Balance: </th>
              <td align="left"> {SPUtilities.coinCountCellFormatter(this.props.pool.balance)}</td>
            </tr>

          </tbody>
        </Table>

        <hr/>
        <p><b>Coins Summary</b></p>
        <Table striped bordered size="sm" >
          <thead>
            <tr>
              <th>Category</th>
              <th>Staked Coins</th>
              <th>Shares</th>
              <th>Weight</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td align="left"> Validator Summary</td>
              <td align="left"> {SPUtilities.coinCountCellFormatter(this.props.pool.total)}</td>
              <td align="left"> {SPUtilities.coinCountCellFormatter(this.props.pool.totalShares)}</td>
              <td align="left"> {SPUtilities.percentFormatter(this.props.pool.stakeWeight, this.props.pool)}</td>
            </tr>
            <tr>
              <td align="left"> Self Bond</td>
              <td align="left"> {SPUtilities.coinCountCellFormatter(this.props.pool.selfBond)}</td>
              <td align="left"> {SPUtilities.coinCountCellFormatter(this.props.pool.selfBondShares)}</td>
              <td align="left"> {SPUtilities.percentFormatter(this.props.pool.selfBondWeight, this.props.pool)}</td>
            </tr>
          </tbody>
        </Table>


        <hr/>
        <p><b>Validator Performance - Running Summary</b>
        <br/>This data does not use completed days and presents pool performance counted backwards from this moment</p>
        {this.getPerfSummaryTable()}
        {!this.state.isLoading && !this.props.hideNav && this.renderPoolNav()}
      </div>
    );
  }

  renderPoolNav() {
    return (<OasisPoolNav poolId={this.props.pool.poolId}/>);
  }

  getPerfSummaryTable() {
    if(RespUtils.isTabletView()) {
      return this.getPerfSummaryTableLarge();
      // getPerfSummaryTableSmall
    } else {
      return this.getPerfSummaryTableLarge();
    }
  }

  getPerfSummaryTableLarge() {
    return (<Table striped bordered size="sm" >
      <thead>
        <tr>
          <th>Epochs</th>
          <th>Signatures</th>
          <th>Missed Signs</th>
          <th>Sign Rate</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td align="left">1</td>
          <td align="left"> {this.props.pool.currentSigned}</td>
          <td align="left"> {this.props.pool.currentMissed}</td>
          <td align="left"> {this.props.pool.currentPerSigned}</td>
        </tr>
        <tr>
          <td align="left">8</td>
          <td align="left"> {this.props.pool.shortSigned}</td>
          <td align="left"> {this.props.pool.shortMissed}</td>
          <td align="left"> {this.props.pool.shortPerSigned}</td>
        </tr>
        <tr>
          <td align="left">24</td>
          <td align="left"> {this.props.pool.dailySigned}</td>
          <td align="left"> {this.props.pool.dailyMissed}</td>
          <td align="left"> {this.props.pool.dailyPerSigned}</td>
        </tr>
        <tr>
          <td align="left">240</td>
          <td align="left"> {this.props.pool.midSigned}</td>
          <td align="left"> {this.props.pool.midMissed}</td>
          <td align="left"> {this.props.pool.midPerSigned}</td>
        </tr>
        <tr>
          <td align="left">720</td>
          <td align="left"> {this.props.pool.longSigned}</td>
          <td align="left"> {this.props.pool.longMissed}</td>
          <td align="left"> {this.props.pool.longPerSigned}</td>
        </tr>
      </tbody>
    </Table>)
  }

  // getPerfSummaryTableSmall() {
  //   return (<Table striped bordered size="sm" >
  //     <thead>
  //       <tr>
  //         <th>Window</th>
  //         <th>Had Validator / Signs</th>
  //         <th>Times Selected / Props</th>
  //         <th>Rewards</th>
  //         <th>Sign Rate</th>
  //       </tr>
  //     </thead>
  //     <tbody>
  //       <tr>
  //         <td align="left">1 hr</td>
  //         <td align="left"> {this.props.pool.hadValidator1Hr} / {this.props.pool.signs1Hr}</td>
  //         <td align="left"> {this.props.pool.timesSelected1Hr} / {this.props.pool.prop1Hr}</td>
  //         <td align="left"> {this.props.pool.rewards1Hr}</td>
  //         <td align="left"> {this.props.pool.signRate1Hr}</td>
  //       </tr>
  //       <tr>
  //         <td align="left">8 hrs</td>
  //         <td align="left"> {this.props.pool.hadValidator8Hrs} / {this.props.pool.signs8Hrs}</td>
  //         <td align="left"> {this.props.pool.timesSelected8Hrs} / {this.props.pool.prop8Hrs}</td>
  //         <td align="left"> {this.props.pool.rewards8Hrs}</td>
  //         <td align="left"> {this.props.pool.signRate8Hrs}</td>
  //       </tr>
  //       <tr>
  //         <td align="left">24 hrs</td>
  //         <td align="left"> {this.props.pool.hadValidator24Hrs} / {this.props.pool.signs24Hrs}</td>
  //         <td align="left"> {this.props.pool.timesSelected24Hrs} / {this.props.pool.prop24Hrs}</td>
  //         <td align="left"> {this.props.pool.rewards24Hrs}</td>
  //         <td align="left"> {this.props.pool.signRate24Hrs}</td>
  //       </tr>
  //       <tr>
  //         <td align="left">7 days</td>
  //         <td align="left"> {this.props.pool.hadValidator7Days} / {this.props.pool.signs7Days}</td>
  //         <td align="left"> {this.props.pool.timesSelected7Days} / {this.props.pool.prop7Days}</td>
  //         <td align="left"> {this.props.pool.rewards7Days}</td>
  //         <td align="left"> {this.props.pool.signRate7Days}</td>
  //       </tr>
  //       <tr>
  //         <td align="left">21 days</td>
  //         <td align="left"> {this.props.pool.hadValidator21Days} / {this.props.pool.signs21Days}</td>
  //         <td align="left"> {this.props.pool.timesSelected21Days} / {this.props.pool.prop21Days}</td>
  //         <td align="left"> {this.props.pool.rewards21Days}</td>
  //         <td align="left"> {this.props.pool.signRate21Days}</td>
  //       </tr>
  //     </tbody>
  //   </Table>)
  // }

  infoNeededMsg() {
    if (this.props.pool.infoNeeded == 'True') {
      // return <p>Do you own this validator? Submit your information <a target="_blank" href="https://forms.gle/qzdV9nBTUSpGf7YZ9">here</a> so that we can update your details.</p>
      return <p>Do you own this validator? Submit your information in <a target="_blank" href="https://github.com/oasisprotocol/metadata-registry">Oasis metadata registry</a> so that we can update your details. You can submit your logo <a target="_blank" href="https://forms.gle/qzdV9nBTUSpGf7YZ9">here</a>.</p>
    }

    return "";
  }

}

// <td align="left"> {SPUtilities.multiAddressSimpleFormatter(this.props.pool.nodes)}</td>

export default OasisPoolInline;



// WEBPACK FOOTER //
// ./src/oasis/OasisPoolInline.js